import selectionActions from './actions';
import selectionHelpers from './helpers';
import selectionReducer, { initialSelectionState } from './reducer';

export default {
  reducer: selectionReducer,
  actions: selectionActions,
  state: initialSelectionState,
  helpers: selectionHelpers,
};
